import Widget from 'domain/entity/widget';
import { ReadWidget } from 'use-case/widget/read/readWidgetUseCase';
import { Option } from 'fp-ts/Option';
import { ErrorData } from 'domain/types';
import { CriteriaCallback, useCase } from 'adapter/in/common/hooks/useCase';
import PresetForm from 'domain/entity/preset/form/presetForm';
import ReadPresetForm from 'use-case/presets/form/readPresetFormClient';

export const usePresetFormUseCase = (
    readPresetFormData: ReadPresetForm
): {
    isLoadingPresetForm: boolean;
    dataPresetForm: Option<PresetForm>;
    errorPresetForm: Option<ErrorData>;
    readPresetForm: CriteriaCallback;
    reset: () => void;
} => {
    const { isLoading, data, error, execute, reset } = useCase(readPresetFormData, false);

    return {
        isLoadingPresetForm: isLoading,
        dataPresetForm: data,
        errorPresetForm: error,
        readPresetForm: execute,
        reset,
    };
};

export const useWidgetUseCase = (
    readWidget: ReadWidget
): {
    isLoadingReadWidget: boolean;
    dataReadWidget: Option<Widget>;
    errorReadWidget: Option<ErrorData>;
    readWidget: CriteriaCallback;
    reset: () => void;
} => {
    const { isLoading, data, error, execute, reset } = useCase(readWidget, false);

    return {
        isLoadingReadWidget: isLoading,
        dataReadWidget: data,
        errorReadWidget: error,
        readWidget: execute,
        reset,
    };
};
